import { flushByTag as redisFlushByTag } from '../redis/redis-tagging';
import {
  getActiveDefaultCacheMeta,
  getDefaultCacheStore,
} from '../stores/store';

import { remove } from './cache';
import { wrapInSentrySpan } from './sentry-support';
import { getTagKey } from './tags';

/**
 * Flushes the whole cache.
 */
export const flush = async () => {
  await wrapInSentrySpan('Flush', async span => {
    span?.setAttributes({
      'sentry.op': 'cache.flush',
      'cache.success': true,
    });

    const cache = await getDefaultCacheStore();

    await cache.clear();
  });
};

/**
 * Flushes all entries related to given tag or tags from the cache.
 */
export const flushByTag = async (tag: string | string[]): Promise<void> => {
  const cacheMeta = await getActiveDefaultCacheMeta();

  //
  // Redis implementation for flushing
  //
  if (cacheMeta?.type === 'redis') {
    return redisFlushByTag(tag);
  }

  const tagsAsArray = typeof tag === 'string' ? [tag] : tag;

  if (tagsAsArray.length === 0) {
    return;
  }

  const tagKeys = tagsAsArray.map(tag => getTagKey(tag));

  const cache = await getDefaultCacheStore();
  const values = await Promise.all(tagKeys.map(key => cache.get<string[]>(key)));

  const keysToFlush = values.reduce<string[]>((collection, keys) => {
    if (keys === null) {
      return collection;
    }

    return [...collection, ...keys];
  }, tagKeys);

  await Promise.all(keysToFlush.map(key => remove(key)));
};
